import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval, tap } from 'rxjs';

@Component({
  selector: 'migration-layout',
  standalone: false,
  templateUrl: './migration-layout.component.html',
  styleUrl: './migration-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MigrationLayoutComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  readonly currentSlideIndex = signal(0);
  readonly slides = [
    {
      title: 'Facturez en toute conformité',
      description: `La plateforme vous accompagne dans l’émission, la réception et la gestion de vos factures électroniques selon les normes fiscales en vigueur. Chaque document généré est automatiquement certifié avec un numéro unique et un QR Code officiel,
     garantissant son authenticité et sa valeur légale.`
    },
    {
      title: 'Gérez vos clients et vos factures en un seul endroit',
      description: `
    La plateforme vous accompagne dans l’émission, la réception et la gestion de vos factures électroniques selon
les normes fiscales en vigueur en Côte d'Ivoire. Chaque document généré est automatiquement certifié avec un
numéro unique et un QR Code officiel, garantissant son authenticité et sa valeur légale.
`
    },
    {
      title: 'Accédez à vos données en toute sécurité 24/7',
      description: `
            La plateforme vous accompagne dans l’émission, la réception et la gestion de vos factures électroniques selon
      les normes fiscales en vigueur en Côte d'Ivoire. Chaque document généré est automatiquement certifié avec un
      numéro unique et un QR Code officiel, garantissant son authenticité et sa valeur légale.
    `
    }
  ];

  ngOnInit(): void {
    this._startAutoPlay();
  }

  private _startAutoPlay(): void {
    interval(8000)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap(() => {
          this.currentSlideIndex.update(
            index => (index + 1) % this.slides.length
          );
        })
      )
      .subscribe();
  }

  goToSlide(index: number): void {
    this.currentSlideIndex.set(index);
  }
}
